import React from 'react';
import PropTypes from 'prop-types';

export default function LikeCounter({ design }) {
    return (
        <span>
            { design.likeCount }
        </span>
    );
}

LikeCounter.propTypes = {
    design: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};



// WEBPACK FOOTER //
// ./src/js/apps/designdetails/components/LikeCounter.jsx